/* ==========================================================================
   NUKKA — marquee.js
   Announcement bar. Seamless CSS loop normally; on prefers-reduced-motion it
   degrades to a static rotating message.
   ========================================================================== */
(function () {
  'use strict';
  var N = window.NUKKA || (window.NUKKA = {});
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  N.register(function (scope) {
    scope.querySelectorAll('[data-marquee]').forEach(function (bar) {
      if (bar._init) return; bar._init = true;
      var track = bar.querySelector('.announcement__track');
      if (!track) return;
      var items = Array.prototype.slice.call(track.children);
      if (!items.length) return;

      if (reduce) {
        // Static: one message at a time, rotate gently.
        bar.classList.add('announcement--static');
        bar.classList.remove('announcement--animate');
        var i = 0;
        items.forEach(function (it, idx) { it.classList.toggle('is-active', idx === 0); });
        if (items.length > 1) {
          setInterval(function () {
            items[i].classList.remove('is-active');
            i = (i + 1) % items.length;
            items[i].classList.add('is-active');
          }, 4000);
        }
        return;
      }

      // Animated: duplicate the item set inside the same track so the
      // translateX(-50%) keyframe loops without a visible jump.
      bar.classList.add('announcement--animate');
      var baseWidth = track.scrollWidth;
      items.forEach(function (it) {
        var clone = it.cloneNode(true);
        clone.setAttribute('aria-hidden', 'true');
        track.appendChild(clone);
      });
      var speed = parseFloat(bar.getAttribute('data-speed')) || 60; // px / sec
      var duration = Math.max(12, baseWidth / speed);
      bar.style.setProperty('--marquee-duration', duration + 's');
    });
  });
})();
